const config = {
  socialMedias: {
    instagram: 'https://www.instagram.com/restoside',
  },
  // In development (npm start), fetch from local nest-brc on 3002; otherwise production URL
  baseURL: process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:3002' : 'https://shark-app-d9vui.ondigitalocean.app'),
  environment: process.env.REACT_APP_ENV || 'production',
  email: {
    serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
    templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '',
    publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '',
  },
  stripe: {
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
  },
}

export default config
